<template>
  <div id="search-form-garden-name">
    <div class="search-form-garden-name__field">
      <label for="gardenSearchInput">Name</label>
      <GardenSearch
        :is-search-page="true"
        :value="value"
        :disabled="disabled"
        @input="$emit('input', $event)"
      />
    </div>
  </div>
</template>

<script>
import GardenSearch from '@/components/header/search/GardenSearch'

export default {
  name: 'SearchFormGardenName',

  components: {
    GardenSearch,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
#search-form-garden-name {
  padding: 16px;
  background-color: $color-search-section-bg;

  .search-form-garden-name__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  label {
    font-family: "Gill Sans", "Inter", sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: $color-text-dark;
    margin-bottom: 0;
  }
}
</style>
